<template>
  <div class="card__wrap">
    <div v-if="simcard" class="card" >
      <div class="header-profile" :class="{blocked: simcard.blocked}">
        <div class="icons">

          <span class="badge" :class="global_status_color(+simcard.status)">
            {{ translate(global_status_text(+simcard.status)) }}
          </span>

          <div class="last_update">
            <span> {{ translate('status') }} {{ translate(global_status_text(+simcard.status)) }} </span>
            <span> {{get_status_from}} </span>
          </div>

        </div>

        <div class="download_to_device">
          <h4 class="title">{{ simcard.device_info ? translate('esim_profile.esim_not_free') : translate('esim_profile.esim_free') }}</h4>

          <div v-if="simcard.device_info" class="current">
            <div class="version">
              <span>
                Device ID: {{ simcard.device_info.device_id }}
                FID: {{ simcard.device_info.device_fid }}
                Slot: {{ simcard.device_info.device_slot }}
              </span>
              <span> User: {{ simcard.device_info.upload_username }} Date: {{ get_date(simcard.device_info.ts_upload) }} </span>
            </div>

            <button class="btn-success btn-fill btn-wd marginButton" @click.prevent="upload_to_device" >
              {{ translate('esim_profile.new_upload') }}
            </button>
          </div>

          <div v-else class="download">
            <button
              class="btn-success btn-fill btn-wd marginButton"
              @click.prevent="download_to_device()"
            >
              {{ translate('esim_profile.new_download') }}
            </button>
          </div>
        </div>

        <div class="linked-cards">
          <div class="linked-card__wrap" v-for="(link, key) in links" :key="key">
            <LinkedSimCard
              v-if="link != null"
              :title="key"
              :simcard="link"
            />
          </div>
        </div>

        <div v-if="profile.blocked" class="esim_blocked">
          <span>{{translate('esim_profile.blocked_use')}}</span>
        </div>

      </div>

      <div class="device_list">
        <EsimHistory
          :profile="simcard"
        />
      </div>

      <div class="content">
        <div v-if="simcard.traffic" class="traffic__wrap">
          <div class="traffic" :style="style_traffic">
            <p v-if="simcard.traffic.limit && simcard.traffic.ts_update">
              <b :style="'color:' + balance_traffic.color"> {{balance_traffic.traffic}} </b>
              <span>
                {{this.translate("simcard_devices.out_of")}}
                <b>
                  {{ parseInt(simcard.traffic.limit/1024) }} GB
                </b>
              </span>
            </p>
          </div>
          <div class="last_update" v-if="simcard.traffic.limit && simcard.traffic.ts_update">
            <p>
              {{translate('simcard_devices.updated')}}
              {{last_update}}
            </p>
          </div>
        </div>

        <form class="simcard-profile">
          <div class="row">
            <div class="col-md-4 col-sm-4">
              <fg-input
                v-model="simcard.msisdn"
                type="text"
                :label="translate('esim_profile.msisdn')"
                :placeholder="translate('esim_profile.msisdn')"
                :readonly="true"
              />
            </div>

            <div class="col-md-4 col-sm-4">
              <fg-input
                v-model="simcard.imsi"
                type="text"
                :label="translate('esim_profile.imsi')"
                :placeholder="translate('esim_profile.imsi')"
                :readonly="true"
              />
            </div>

            <div class="col-md-4 col-sm-4">
              <fg-input
                v-model="simcard.iccid"
                type="text"
                :label="translate('esim_profile.iccid')"
                :placeholder="translate('esim_profile.iccid')"
                :readonly="true"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 col-sm-4">
              <fg-input
                v-model="simcard.mno_name"
                type="text"
                :label="translate('esim_profile.mno')"
                :placeholder="translate('esim_profile.mno')"
                :readonly="true"
              />
            </div>
            <div class="col-md-4 col-sm-4">
              <fg-input
                v-model="simcard.parent_mno"
                type="text"
                :label="translate('esim_profile.parent_mno')"
                :placeholder="translate('esim_profile.parent_mno')"
                :readonly="true"
              >
              </fg-input>
            </div>
            <div class="col-md-4 col-sm-4">
              <fg-input
                v-model="simcard.tariff"
                type="text"
                :label="translate('esim_profile.tariff')"
                :placeholder="translate('esim_profile.tariff')"
                :readonly="true"
              >
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 col-sm-6">
              <fg-input
                v-model="simcard.username"
                type="text"
                :label="translate('esim_profile.username')"
                :placeholder="translate('esim_profile.username')"
                :readonly="true"
              />
            </div>
            <div class="col-md-6 col-sm-6">
              <fg-input
                v-model="created"
                type="text"
                :label="translate('esim_profile.ts_create')"
                :placeholder="translate('esim_profile.ts_create')"
                :readonly="true"
              >
              </fg-input>
            </div>
          </div>

          <div class="clearfix" />
        </form>

      </div>

      <div class="simcard_list">
        <RelatedProfiles
          v-if="simcard.related_profiles"
          title="Related Profiles"
          :simcard_list="simcard.related_profiles"
        />
      </div>

      <div class="text-center">
        <span
          class="btn btn-danger btn-wd"
          @click="blockedEsim()"
          v-if="this.$store.getters.getPermissions.permissionGod === true"
        >
        {{ (!simcard.blocked)? this.translate('block') : this.translate('unblock') }}
        </span>
      </div>
    </div>


    <div class="history_action__wrap">
      <Summary
        type="esim_profile"
        :info="simcard"
      />
    </div>
  </div>

</template>
<script>

import RelatedProfiles from './RelatedProfiles.vue'
import LinkedSimCard from 'components/UIComponents/Icon/LinkedSimCard.vue'
import EsimHistory from './EsimHistory.vue'
import DownloadToDevice from './Modal/DownloadToDevice.vue'
import UploadToDevice from './Modal/UploadToDevice.vue'
import ModalBlock from './Modal/Block.vue'
import Summary from "components/UIComponents/Summary/Summary.vue";

export default {
  components: {
    RelatedProfiles,
    LinkedSimCard,
    EsimHistory,
    Summary
  },

  props: {
    profile: {
      type: [Array, Object],
      default: () => []
    }
  },

  created() {
    this.update_sim()
    this.check_links(this.simcard)
  },
  data () {
    return {
      ch_group: false,
      showBlock: true,
      simcard: {
        type: [Array, Object],
        default: () => []
      },
      editNumber: true,
      editOperator: true,
      links: {}
    }
  },

  computed: {
    opt_groups () {
     return this.$store.getters.getSimcardDevicesGroupsTree
    },
    balance_traffic(){
      return this.traffic_balance(this.simcard.traffic)
    },

    style_traffic() {
      return this.traffic_style(this.simcard.traffic)
    },

    last_update(){
      let ts = new Date().getTime()/1000
      var duration = parseInt(ts - this.simcard.traffic.ts_update);
      let minutes = 0
      let hours = parseInt((duration/(60*60)));
      if (hours < 5) {
        minutes = parseInt((duration/60));
        return minutes + " " + this.translate('simcard_devices.min_ago')
      }
      minutes = parseInt((duration/60)%60);
      return hours + " " + this.translate('simcard_devices.h_ago')
    },

    get_status_from(){
      return this.translate('from') + ' ' + this.get_date(this.simcard.ts_status_update);
    },
    created(){
      return this.get_date(this.simcard.ts_create)
    }
  },

  watch : {
    profile: {
      deep: true,
      handler () {
        this.update_sim()
        this.check_links(this.simcard)
      }
    }
  },

  methods: {
    blockedEsim(){
      let new_status = this.simcard.blocked === 1 ? 0 : 1
      var t = this.$createElement(ModalBlock, {
        props: {
          new_status,
          simcard: this.simcard
        },
        on: {
          close: () => { this.$modal.hide('dynamic-modal') },
          update: () => { this.$emit('change') }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: false, scrollable: true, name: 'dynamic-modal'})
    },
    check_links (sim) {
      let params = {
        "msisdn": sim.msisdn ? sim.msisdn : sim.number,
        "iccid": sim.iccid,
        "imsi": sim.imsi
      }

      this.$http.simcard.getAllSimcards(params, (response) => {
        let links = {}
        for (let index in response.data) {
          if (index !== 'status' && index !== 'esim_profile' && response.data[index]) {
            links[index] = response.data[index]
          }
        }
        this.$set(this, 'links', links)
      },(bad_answer) => {
        this.bad_answer_handler(bad_answer)
      })
    },
    download_to_device(){
      let t = this.$createElement(DownloadToDevice, {
        props:{
          iccid: this.simcard.iccid
        },
        on: {
          close: () => { this.$modal.hide('download-to-device') },
          update: () => { this.$emit('change') }
        }
      })
      let temp = {
        render () { return t }
      }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'download-to-device'})
    },
    upload_to_device(){
      let t = this.$createElement(UploadToDevice, {
        props:{
          esim_id: this.simcard.id
        },
        on: {
          close: () => { this.$modal.hide('upload-to-device') },
          update: () => { this.$emit('change') }
        }
      })
      let temp = {
        render () { return t }
      }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'upload-to-device'})
    },
    update_sim(){
      this.simcard = {...this.profile}
      !this.simcard.number ? this.editNumber = false : this.editNumber = true
      !this.simcard.operator ? this.editOperator = false : this.editOperator = true
    },
    check_empty(data){
      return !!data;
    },

    cancel () {
      this.init = true
      this.simcard = {...this.profile}
    },
  }
}

</script>

<style lang='scss' scoped>
  .card{
    padding-left: 0;
    padding-right: 0;
    width: calc(70% - 10px);
    margin-right: 10px;
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    &__wrap{
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }

    .header-profile {
      padding: 10px 8px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      min-height: 74px;
      height: 120px;
      &.blocked{
        border: 2px solid #f3bb45;
        padding-left: 130px;
        .esim_blocked{
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 125px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #f3bb45;
          color: white;
          font-size: 12px;
          span{
            text-align: center;
          }
        }
      }
      .icons{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .badge{
          padding: 10px;
          font-size: 16px;
        }
        .last_update{
          text-align: center;
          span{
            display: block;
          }
        }

      }

      .download_to_device{
        margin: 0 10px;
        border-radius: 10px;
        box-shadow: 0 2px 2px #ccc5b980;
        color: #252422;
        padding-bottom: 0;
        position: relative;
        border: 1px solid #ccc;
        background-color: #f8f8f8;
        min-width: 200px;
        height: 100%;
        h4.title {
          font: 300 12px/16px "Roboto", Arial, sans-serif;
          color: #000;
          background: #f4f3ef;
          padding: 5px 10px;
          border-radius: 10px 10px 0 0;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .current{
          padding: 0 5px;
          border-top: 1px solid #ccc;
          .version {
            font-size: 10px;
            color: #9A9A9A;
            text-align: center;
            padding: 5px 0 0;
            span{
              display: block;
            }
          }
          button{
            display: block;
            margin: 5px auto;
          }
        }
        .download{
          height: 70%;
          border-top: 1px solid #ccc;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      .linked-cards{
        height: 100px;
        display: flex;
        cursor: pointer;
        margin-left: auto;
        .linked-card__wrap{
          height: 100%;
          margin-right: 5px;
          &:last-child{
            margin-right: 0;
          }
        }
      }
    }

    .content{
      display: flex;
      justify-content: center;
      align-items: flex-start;

      .simcard-profile{
        width: 100%;
      }
    }

    .button_div {
      padding-bottom: 10px;
      padding-top: 5px;
    }

    .table_ip_tr {
      background-color: #eee !important;
    }
  }

  .history_action__wrap{
    width: 30%;
    height: 100%;
    border-radius: 3px;
    box-shadow: 0 2px 2px #ccc5b980;
    color: #252422;
    position: relative;
    border: 1px solid #ccc;
    background-color: #f8f8f8;
  }

  .simcard_list{
    padding-top: 10px;
  }

  @media (max-width:1350px){
    .card{
      width: 100%;
      height: auto;
      min-height: inherit;
      margin-bottom: 10px;
      &__wrap{
        height: auto;
        flex-direction: column;
        padding-bottom: 10px;
      }
    }
    .history_action__wrap{
      width: 100%;
      height: auto;
    }
  }

  @media (max-width:600px){
    .card{
      .header-profile {
        align-items: center;
        flex-direction: column;
        height: auto;
        &>div{
          margin: 5px;
        }
        .linked-card__wrap{
          margin-left: 5px;
          height: 90px;
        }
      }
    }
  }

  @media (max-width:500px){
    .card{
      .content{
        align-items: center;
        flex-direction: column;
      }
    }
  }
</style>
